import { Link } from 'react-router-dom';
import {
  ShieldCheckIcon,
  BuildingOfficeIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';
import { useUser } from '../contexts/UserContext';

const Card = ({ to, icon: Icon, iconBg, iconColor, title, description }) => (
  <Link
    to={to}
    className="bg-white shadow rounded-lg p-6 hover:shadow-md transition-shadow flex flex-col gap-4 group"
  >
    <div className={`p-3 rounded-full w-fit ${iconBg}`}>
      <Icon className={`h-6 w-6 ${iconColor}`} />
    </div>
    <div className="flex-1">
      <h3 className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">{title}</h3>
      <p className="text-sm text-gray-500 mt-1">{description}</p>
    </div>
    <div className="flex items-center text-sm text-blue-600 font-medium">
      Open <ArrowRightIcon className="h-4 w-4 ml-1 group-hover:translate-x-0.5 transition-transform" />
    </div>
  </Link>
);

export default function ControlCenter() {
  const { isAdmin } = useUser();

  if (!isAdmin()) return null;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Security Center</h1>
        <p className="text-sm text-gray-500 mt-1">Azure cloud security posture and recommendations</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card
          to="/secure-score"
          icon={ShieldCheckIcon}
          iconBg="bg-red-50"
          iconColor="text-red-600"
          title="Azure Secure Score"
          description="Azure Defender for Cloud security posture and recommendations"
        />

        <Card
          to="/m365-secure-score"
          icon={BuildingOfficeIcon}
          iconBg="bg-blue-50"
          iconColor="text-blue-600"
          title="Microsoft 365 Secure Score"
          description="Microsoft Security Center posture, control recommendations, and licence-filtered action items"
        />
      </div>
    </div>
  );
}
